'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNumSoftDeletedMessages = exports.getVisitorLastReadAtTimestamp = exports.getEndTimestamp = exports.getStartTimestamp = exports.getMessages = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessages = exports.getMessages = (0, _getIn2.default)(_keyPaths.MESSAGES);

var getStartTimestamp = exports.getStartTimestamp = (0, _getIn2.default)(_keyPaths.START_TIMESTAMP);

var getEndTimestamp = exports.getEndTimestamp = (0, _getIn2.default)(_keyPaths.END_TIMESTAMP);

var getVisitorLastReadAtTimestamp = exports.getVisitorLastReadAtTimestamp = (0, _getIn2.default)(_keyPaths.VISITOR_LAST_READ_AT_TIMESTAMP);

var getNumSoftDeletedMessages = exports.getNumSoftDeletedMessages = (0, _getIn2.default)(_keyPaths.NUM_SOFT_DELETED_MESSAGES);